import axios from 'axios';
import { getApiBaseUrl } from './api';

export interface ApiKey {
  id: string;
  client_id: string;
  name: string;
  key_prefix: string;
  scopes: string[];
  last_used_at: string | null;
  revoked_at: string | null;
  created_at: string;
}

/** Returned ONLY on create — the full plaintext key. Never persisted client-side. */
export interface CreatedApiKey extends ApiKey {
  key: string;
}

const base = (clientId: string) => `${getApiBaseUrl()}/clients/${clientId}/api-keys`;

export const sdkKeysApi = {
  async list(clientId: string, includeRevoked = false): Promise<ApiKey[]> {
    const res = await axios.get<{ data: ApiKey[] }>(base(clientId), {
      params: { include_revoked: includeRevoked },
    });
    return res.data.data;
  },

  async create(clientId: string, name: string): Promise<CreatedApiKey> {
    const res = await axios.post<{ data: CreatedApiKey }>(base(clientId), { name });
    return res.data.data;
  },

  async revoke(clientId: string, keyId: string): Promise<void> {
    await axios.delete(`${base(clientId)}/${keyId}`);
  },
};
